package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.fontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLButtonElement

val buttonStyles: StyleSheet.() -> Unit = {
    ".button" style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        padding(0.5.cssRem, 1.cssRem)
        backgroundColor(rgba(0, 0, 0, 0))
        color(Color.black)
        cursor("pointer")
        textDecoration("none")
        fontSize(0.85.cssRem)
        borderRadius(100.px)
        fontWeight(FontWeight.Bold)
        border {
            style = LineStyle.Solid
            color = rgb(126, 126, 126)
            width = 1.px
        }
    }

    ".button:active" style {
        backgroundColor(rgb(194, 194, 194))
    }
    ".button:hover" style {
        backgroundColor(rgb(208, 208, 208))
    }

    ".button-primary" style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        padding(0.5.cssRem, 1.cssRem)
        backgroundColor(rgb(35, 0, 96))
        color(Color.white)
        cursor("pointer")
        textDecoration("none")
        fontSize(0.85.cssRem)
        borderRadius(100.px)
        fontWeight(FontWeight.Bold)
        border {
            style = LineStyle.None
            width = 0.px
        }
    }

    ".button-primary:active" style {
        backgroundColor(rgb(25, 0, 70))
    }
    ".button-primary:hover" style {
        backgroundColor(rgb(50, 10, 120))
    }
}

@Composable
fun StyledButton(
    text: String,
    onClick: ((SyntheticMouseEvent) -> Unit)? = null,
    name: String? = null,
    type: ButtonType? = null,
    value: String? = null,
    disabled: Boolean = false,
    primary: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Button({
        classes(if (primary) "button-primary" else "button")
        name?.let { name(name) }
        type?.let { type(type) }
        value?.let { value(value) }
        this.onClick { onClick?.invoke(it) }
        if (disabled) {
            disabled()
        }
        modifier.toAttrs<AttrsScope<HTMLButtonElement>>().invoke(this)
    }) {
        Text(text)
    }
}
